module.exports = "<svg width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.988 7.173l6.13 6.153a.599.599 0 0 1-.42 1.02.594.594 0 0 1-.422-.175l-6.13-6.153-6.13 6.153a.591.591 0 0 1-.841 0 .599.599 0 0 1 0-.845l6.13-6.153L.174 1.02a.599.599 0 0 1 0-.845.594.594 0 0 1 .841 0l6.13 6.152 6.13-6.152a.594.594 0 0 1 .842 0 .6.6 0 0 1 0 .845l-6.13 6.153z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=true!./src/images/navigation/close.svg
// module id = /xdp
// module chunks = 89